import { render, staticRenderFns } from "./donations.vue?vue&type=template&id=07a12851&"
import script from "./donations.vue?vue&type=script&lang=js&"
export * from "./donations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports